import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { QuestionTopicTag } from '../../app/question-bank.model';

@Component({
  selector: 'dojo-question-topic-tags',
  templateUrl: './question-topic-tags.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatTooltip],
  host: { class: 'block' },
})
export class QuestionTopicTagsComponent {
  readonly topics = input<QuestionTopicTag[], QuestionTopicTag[] | null | undefined>([], {
    transform: (value) => value ?? [],
  });
}
